import * as R from 'ramda'
import { getDeviceInfo } from 'helpers/useragent'
import { GetURLByDeviceType, GetViewDeviceType, GetWebDeviceType } from './context.types'

const getWebDeviceType: GetWebDeviceType = isLargeViewport => isLargeViewport ? 'desktop' : 'mobile'

export const getViewDeviceType: GetViewDeviceType = (isLargeViewport) => (
  R.ifElse(
    R.identity,
    R.always('webview'),
    R.always(getWebDeviceType(isLargeViewport))
  )(R.prop('webview', getDeviceInfo()))
)

export const getURLByDeviceType: GetURLByDeviceType = (context, isLargeViewport, urlType) => {
  const device = getViewDeviceType(isLargeViewport)
  return R.path([device, urlType])(context)
}
